import {
    FETCH_PLAYER_ALERTS,
    FETCH_PLAYER_ALERTS_FAIL,
    FETCH_PLAYER_ALERTS_SUCCESS,
    FETCH_PLAYER_DETAILS,
    FETCH_PLAYER_DETAILS_FAIL,
    FETCH_PLAYER_DETAILS_SUCCESS,
    FETCH_PLAYER_EVENTS,
    FETCH_PLAYER_EVENTS_FAIL,
    FETCH_PLAYER_EVENTS_SUCCESS
} from './actionTypes';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../../../services/Paging';

const initialState = {
    data: {},
    events: {
        data: [],
        pagination: {
            pageSize: defaultItemsPerPage,
            page: defaultFirstPage,
            hasNextPage: false
        },
        sort: {
            sortType: 'EVENT_TIMESTAMP',
            sortOrder: 'ASC'
        },
        error: null,
        loading: false,
        loaded: false
    },
    alerts: {
        data: [],
        pagination: {
            pageSize: defaultItemsPerPage,
            page: defaultFirstPage,
            hasNextPage: false
        },
        error: null,
        loading: false,
        loaded: false
    },
    error: null,
    loading: false,
    loaded: false
};

export function playerReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PLAYER_DETAILS: {
            return {
                ...state,
                loading: true
            };
        }
        case FETCH_PLAYER_DETAILS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                loaded: true,
                loading: false
            };
        }
        case FETCH_PLAYER_DETAILS_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        case FETCH_PLAYER_ALERTS: {
            return {
                ...state,
                alerts: {
                    ...initialState.alerts,
                    pagination: {
                        ...initialState.alerts.pagination,
                        ...action.payload.pagination
                    },
                    loading: true
                }
            };
        }
        case FETCH_PLAYER_ALERTS_SUCCESS: {
            return {
                ...state,
                alerts: {
                    ...initialState.alerts,
                    data: action.payload.result,
                    pagination: {
                        ...state.alerts.pagination,
                        hasNextPage: action.payload.hasNext
                    },
                    loading: false,
                    loaded: true
                }
            };
        }
        case FETCH_PLAYER_ALERTS_FAIL: {
            return {
                ...state,
                alerts: {
                    ...initialState.alerts,
                    error: action.payload
                }
            };
        }
        case FETCH_PLAYER_EVENTS: {
            const { sort, pagination } = action.payload;
            return {
                ...state,
                events: {
                    ...initialState.events,
                    sort: {
                        ...initialState.events.sort,
                        ...sort
                    },
                    pagination: {
                        ...initialState.events.pagination,
                        ...pagination
                    },
                    loading: true
                }
            };
        }
        case FETCH_PLAYER_EVENTS_SUCCESS: {
            return {
                ...state,
                events: {
                    ...initialState.events,
                    data: action.payload.result,
                    pagination: {
                        ...state.events.pagination,
                        hasNextPage: action.payload.hasNext
                    },
                    loaded: true
                }
            };
        }
        case FETCH_PLAYER_EVENTS_FAIL: {
            return {
                ...state,
                events: {
                    ...initialState.alerts,
                    error: action.payload
                }
            };
        }
        default:
            return state;
    }
}
